<template>
  <!-- 菜单列表的按钮组，如果是多个按钮，使用按钮分组 -->
  <div class="button-group">
    <el-dropdown v-show="moreButton" @command="toCommand">
      <span class="el-dropdown-link">
        {{ label || $t("message.operation") }}<yq-icon name="element-ui_arrow-down"/>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="(it, i) in buttonList" :key="i" :command="it.id"><span :class="`button button-${it.elType} button-disable-${it.disabled}`">{{ it.label }}</span></el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <div v-show="!moreButton" class="button-group-more">
      <slot></slot>
    </div>
  </div>
</template>

<script>

import {getCurrentInstance} from "vue";
import {useRoute, useRouter} from "vue-router";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  props: {
    label: {default: ""},
    btnCount: {default: 3}
  },
  name: "TBG",
  components: {
  },
  data() {
    return {
      moreButton: false,
      buttonList: []
    };
  },
  created() {
    const ins = getCurrentInstance();
    if (ins && ins.slots.default) {
      const slotContent = ins.slots.default();
      // 有对应的对象
      if (slotContent && slotContent.length > this.btnCount) {
        console.log(`tablebutton-length${slotContent.length}`)
        this.moreButton = true;
      }
    }
  },
  methods: {
    // 点击下拉菜单
    toCommand(buttonId) {
      // 通过id找到document然后click
      for (let i = 0; i < this.buttonList.length; i++) {
        if (this.buttonList[i].id === buttonId) {
          this.buttonList[i].button.clickEvent();
          break;
        }
      }
    },
    // 添加button时注册进来
    addButton(data) {
      this.buttonList.push(data)
    }
  }
};
</script>

<style lang="scss" scoped>
.button-group{
  vertical-align: middle;
  display: inline-flex;
  .el-dropdown-link{
    color: var(--el-color-primary);
    font-size: 12px;
    vertical-align: middle;
    line-height: 24px;
  }
}
.button{
  font-size: 14px;
  display: block;
  min-width: 80px;
}
.button-primary{
  color: var(--el-color-primary);
}
.button-danger{
  color: var(--el-color-danger);
}
.button-success{
  color: var(--el-color-success);
}
.button-info{
  color: var(--el-color-info);
}
.button-disable-true{
  color: var(--el-color-info); // 禁用
  cursor: not-allowed;
}
</style>